import { render } from "./stars.vue?vue&type=template&id=05bbdc62&scoped=true"
import script from "./stars.vue?vue&type=script&lang=js"
export * from "./stars.vue?vue&type=script&lang=js"

import "./stars.vue?vue&type=style&index=0&id=05bbdc62&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05bbdc62"]])

export default __exports__